// extracted by mini-css-extract-plugin
export var divider = "_2b-0";
export var dividerText = "_2b-1";